import React from "react";

/**
 * Branded SVG illustration of an effervescent tube
 * Color is the product's accent color used for the cap ring + dark band detail
 */
export default function TubeArt({ name = "ReDrive", suffix = "MAX", color = "#7CB342", flavor = "ZESTY LIME",
    unitCopy = "", count = null, lines = null, className = "" }) {
    const [first, ...rest] = name.split(" ");
    const titleMain = first || name;
    const titleSuffix = suffix || rest.join(" ");
    const unit = (unitCopy || "EFFERVESCENT TABLETS").toUpperCase();
    const copy = (Array.isArray(lines) ? lines : ["DAILY VITALITY.", "CONFIDENCE.", "PERFORMANCE."]).slice(0, 3);

    return (
        <svg viewBox="0 0 240 480" className={className} xmlns="http://www.w3.org/2000/svg" aria-label={`${name} tube`}>
            <defs>
                <linearGradient id={`bg-${color}`} x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0" stopColor="#ffffff" />
                    <stop offset="0.5" stopColor="#f5f5f5" />
                    <stop offset="1" stopColor="#dcdcdc" />
                </linearGradient>
                <linearGradient id={`dark-${color}`} x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0" stopColor="#181818" />
                    <stop offset="0.5" stopColor="#0A0A0A" />
                    <stop offset="1" stopColor="#1d1d1d" />
                </linearGradient>
                <filter id="soft-shadow" x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="0" dy="20" stdDeviation="18" floodColor="#000" floodOpacity="0.5" />
                </filter>
            </defs>

            {/* Tube body white */}
            <rect x="50" y="60" width="140" height="220" rx="4" fill={`url(#bg-${color})`} filter="url(#soft-shadow)" />

            {/* Gold band */}
            <rect x="50" y="278" width="140" height="14" fill="#F5C518" />

            {/* Dark bottom */}
            <rect x="50" y="292" width="140" height="160" rx="4" fill={`url(#dark-${color})`} />

            {/* Cap top */}
            <rect x="46" y="30" width="148" height="32" rx="6" fill="#EAEAEA" />
            {/* Cap ring (color) */}
            <rect x="46" y="20" width="148" height="14" rx="7" fill={color} />

            {/* Logo Re circle */}
            <circle cx="120" cy="110" r="22" fill="none" stroke={color} strokeWidth="6" />
            <text x="120" y="118" textAnchor="middle" fontFamily="'Cabinet Grotesk', sans-serif" fontWeight="900" fontSize="20" fill="#0A0A0A">Re</text>

            {/* Title vertical */}
            <text x="120" y="200" textAnchor="middle" fontFamily="'Cabinet Grotesk', sans-serif" fontWeight="900" fontSize="32" fill="#0A0A0A">{titleMain}</text>
            <text x="120" y="232" textAnchor="middle" fontFamily="'Cabinet Grotesk', sans-serif" fontWeight="900" fontSize="22" fill={color === "#7CB342" ? "#F5C518" : color}>{titleSuffix}</text>
            <text x="120" y="252" textAnchor="middle" fontFamily="'Manrope', sans-serif" fontWeight="700" fontSize="8" letterSpacing="1.2" fill="#525252">{unit}</text>

            {/* Dark band copy */}
            {copy.map((line, i) => (
                <text key={i} x="120" y={330 + i * 18} textAnchor="middle" fontFamily="'Cabinet Grotesk', sans-serif"
                    fontWeight="800" fontSize="12" fill={i === copy.length - 1 ? color : "#fff"}>{line}</text>
            ))}

            {/* Flavor */}
            {!!flavor && (
                <>
                    <rect x="68" y="386" width="104" height="22" rx="3" fill="#F5C518" />
                    <text x="120" y="402" textAnchor="middle" fontFamily="'Cabinet Grotesk', sans-serif" fontWeight="800" fontSize="11" fill="#0A0A0A">{flavor}</text>
                </>
            )}

            {/* Unit count */}
            {!!count && (
                <text x="120" y="430" textAnchor="middle" fontFamily="'Cabinet Grotesk', sans-serif" fontWeight="900" fontSize="20" fill="#fff">{count}</text>
            )}
            <text x="120" y={count ? 448 : 432} textAnchor="middle" fontFamily="'Manrope', sans-serif" fontWeight="700" fontSize="7.5" letterSpacing="1.2" fill="#a3a3a3">{unit}</text>
        </svg>
    );
}
